import { render } from "./Slide8.vue?vue&type=template&id=56421a30&scoped=true"
import script from "./Slide8.vue?vue&type=script&lang=js"
export * from "./Slide8.vue?vue&type=script&lang=js"

import "./Slide8.vue?vue&type=style&index=0&id=56421a30&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56421a30"]])

export default __exports__